import $ from 'jquery';
import { fabric } from 'fabric';
import { setCursorRadius, toggleObjectEraser } from '~core';
import { getState } from '~src/state';

export const initEraser = () => {
  window.canvas.freeDrawingBrush = new fabric.EraserBrush(window.canvas);

  const eraserRadius = getState('eraserRadius');
  $('#editor-object-eraser-slider').val(eraserRadius);

  window.canvas.freeDrawingBrush.width = eraserRadius * 2;
  window.canvas.freeDrawingBrush.inverted = false;

  setCursorRadius(eraserRadius);

  $('.eraser-preview').css({
    width: `${eraserRadius}px`,
    height: `${eraserRadius}px`,
  });

  $('body').on('click', function (event) {
    const isErasing = getState('isErasing', false);
    const excludeIds = [
      'editor-object-eraser-slider',
      'editor-menu-object-eraser',
      'editor-menu-undo-eraser',
      'editor-menu-undo-eraser',
      'editor-object-eraser-controls',
      'editor-zoom-controls',
    ];
    let isChildOfEraserBox = false;

    $(event.target)
      .parents()
      .each((_, el) => {
        if (excludeIds.includes(el.id)) {
          isChildOfEraserBox = true;
        }
      });

    const shouldSkip =
      isChildOfEraserBox || excludeIds.includes(event.target.id);

    if (shouldSkip) {
      return;
    }

    if (isErasing) {
      toggleObjectEraser();
    }
  });
};
